export enum FionaProducts {
	Loans = 'loans',
	LifeInsurance = 'life-insurance',
	Insurance = 'insurance',
	AutoInsurance = 'auto-insurance',
	StudentLoanRefinance = 'student-loan-refinance',
	CreditCards = 'credit-cards',
	Savings = 'savings',
	Mortgages = 'mortgage'
}

export enum FionaTopics {
	DebtConsolidation = 'debt-consolidation'
}
